import { useTranslation } from 'react-i18next';

import { CustomModal } from 'components/shared';
import { useErrorDescriptions } from 'constants/errorDescriptions';
import { useModal } from 'hooks/useModal';
import { OrderDetailsDTO } from 'interfaces';
import { HTTPService } from 'service';
import { logNetworkError } from 'utils/logNetworkError';

import styles from './SendOrderForPaymentModal.module.css';

type SendOrderForPaymentModalProps = {
   orderId: string;
   onSuccessSendForPayment: (updatedOrder: OrderDetailsDTO) => void;
   hasAdditionalCharges?: boolean;
   opened: boolean;
   onClose: () => void;
};

const SendOrderForPaymentModal = ({
   orderId,
   onSuccessSendForPayment,
   hasAdditionalCharges,
   opened,
   onClose,
}: SendOrderForPaymentModalProps) => {
   const { t } = useTranslation();
   const { isLoading, errorInfo, setIsLoading, setErrorInfo, closeModalHandler } = useModal({
      onClose,
   });

   const { DEFAULT_ERROR_DESCRIPTIONS } = useErrorDescriptions();

   const handleSendOrderForPayment = () => {
      setIsLoading(true);
      HTTPService.changeOrderStatus(orderId, 'TO_PAY')
         .then(response => {
            onSuccessSendForPayment(response.data);
            closeModalHandler();
         })
         .catch(error => {
            setErrorInfo(DEFAULT_ERROR_DESCRIPTIONS.UNKNOWN);
            logNetworkError(error);
         })
         .finally(() => setIsLoading(false));
   };

   return (
      <CustomModal
         opened={opened}
         onClose={closeModalHandler}
         isLoading={isLoading}
         error={errorInfo}
         title={
            hasAdditionalCharges
               ? t('send_order_for_payment_modal.title_with_charges')
               : t('order_details_page.send_to_payment')
         }
         innerTitle={t('common.warning')}
         icon="ALERT_TRIANGLE"
         primaryButtonProps={{
            text: hasAdditionalCharges
               ? t('sendToSettlement.primaryButtonWithCharges')
               : t('order_details_page.send_to_payment'),
            variant: 'filled-primary',
            onClick: handleSendOrderForPayment,
         }}
         secondaryButtonProps={{
            text: t('common.cancel'),
            variant: 'text',
            onClick: closeModalHandler,
         }}
         size={670}
         leftSideModalContent
         modalContentClassName={styles.modalContent}
      >
         <p>{t('send_order_for_payment_modal.confirm')}</p>
         <p>{t('cancel_pallet_report_modal.irreversible')}</p>
      </CustomModal>
   );
};

export default SendOrderForPaymentModal;
